import parseHTML from "html-react-parser"

const nl2br = (text) => {
  if (!text) {
    return
  }

  return parseHTML(text.replace(/[\r\n\u0085\u2028\u2029]+/g, "<br />"))
}

export default nl2br
